var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { useInlineReportMutation } from "../../../hooks/useInlineReportMutation";
import { createAnnualReportSchema } from "../../../utils/validationUtils";
import { generateAnnualReport } from "../../../api/reportsService";
import { RecekDatepicker } from "../../inputs/RecekDatepicker";
import { AnnualReportResults } from "./AnnualReportResults";
import { ReportSubmitSection } from "./ReportSubmitSection";
var toIsoDate = function (val) {
    var m = moment(val, "DD/MM/YYYY", true);
    return m.isValid() ? m.format("YYYY-MM-DD") : val;
};
var transformFormToApiParams = function (data) { return ({
    periodFrom: toIsoDate(data.periodFrom),
    periodTo: toIsoDate(data.periodTo),
}); };
var getDefaultValues = function () { return ({
    periodFrom: "",
    periodTo: "",
}); };
export var AnnualReportForm = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useForm({
        resolver: zodResolver(createAnnualReportSchema(formatMessage)),
        defaultValues: getDefaultValues(),
    }), control = _a.control, handleSubmit = _a.handleSubmit;
    var _b = useInlineReportMutation({
        generateReport: function (reportKy, data) {
            return generateAnnualReport(reportKy, transformFormToApiParams(data));
        },
        successMessageId: "ui-br-agency.outputs.annual-report.success.generate",
        errorMessageId: "ui-br-agency.outputs.annual-report.error.generate",
    }), mutate = _b.mutate, isLoading = _b.isLoading, reportData = _b.data, successMessage = _b.successMessage, clearSuccessMessage = _b.clearSuccessMessage, errorModalOpen = _b.errorModalOpen, errorMessage = _b.errorMessage, closeErrorModal = _b.closeErrorModal;
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: handleSubmit(function (data) { return mutate(data); }) },
            React.createElement("h2", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.report.annual-report" })),
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.annual-report.description" })),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 4 },
                    React.createElement(Controller, { control: control, name: "periodFrom", render: function (_a) {
                            var _b;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(RecekDatepicker, __assign({}, field, { labelId: "ui-br-agency.outputs.annual-report.field.periodFrom", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true, backendDateStandard: "ISO 8601", dateFormat: "DD/MM/YYYY" })));
                        } })),
                React.createElement(Col, { xs: 12, md: 4 },
                    React.createElement(Controller, { control: control, name: "periodTo", render: function (_a) {
                            var _b;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(RecekDatepicker, __assign({}, field, { labelId: "ui-br-agency.outputs.annual-report.field.periodTo", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true, backendDateStandard: "ISO 8601", dateFormat: "DD/MM/YYYY" })));
                        } }))),
            React.createElement(ReportSubmitSection, { isLoading: isLoading, generateButtonId: "ui-br-agency.outputs.annual-report.button.generate", successMessage: successMessage, onSuccessDismiss: clearSuccessMessage, errorModalOpen: errorModalOpen, errorMessage: errorMessage, onErrorClose: closeErrorModal })),
        reportData && React.createElement(AnnualReportResults, { data: reportData })));
};
